import { StandardEntity } from '@infodata-group/inf-commons';
import { FleetDriverDto } from '../interface/fleet-driver.dto';

export class FleetDriver extends StandardEntity {
  public name: string;
  public firstname: string;
  public date: string;
  public type: string;
  public pricePerKm: number;
  public active: boolean;

  get stateFormater(): string {
    return this.active ? 'Actif' : 'Inactif';
  }

  public address: string;
  public postalCode: string;
  public city: string;
  public phoneNumber: string;
  public team: {
    id: string;
    label: string;
  };
  public breakPerDay: string;
  public identificationKey: string;
  public job: {
    id: string;
    label: string;
  };
  public remarks: [string];
  public limosa: string;
  public niss: string;
  public lisaBdg: string;

  public override serialize(): FleetDriverDto {
    return {
      id: this.id,
      label: this.label,
      icon: this.icon,
      name: this.name,
      firstname: this.firstname,
      date: this.date,
      type: this.type,
      pricePerKm: this.pricePerKm,
      active: this.active,
      address: this.address,
      postalCode: this.postalCode,
      city: this.city,
      phoneNumber: this.phoneNumber,
      team: this.team,
      breakPerDay: this.breakPerDay,
      identificationKey: this.identificationKey,
      job: this.job,
      remarks: this.remarks,
      limosa: this.limosa,
      niss: this.niss,
      lisaBdg: this.lisaBdg,
    };
  }
}
